/* src/app/_shared/components/appointment-edit-tags/appointment-edit-tags.modal.scss */
.tag-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: calc(var(--space-right) / 2);
  padding: 0;
  border-radius: 3px;
  color: #444444;
  font-weight: normal;
  font-size: 0.9em;
  vertical-align: middle;
}
.tag-description {
  display: inline-block;
  vertical-align: middle;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
/*# sourceMappingURL=appointment-edit-tags.modal.css.map */
